import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import store from "../../../store";
import { dataStoreServeices } from "../../../services/api/datastore-request.endpoints";
import {
  setQuaryContent,
  setQueryContentSingle,
  setDbMetaDataPostFailed,
  setOutputValues,
  setCreateBizQueryFailed,
  setHasErrorMessage,
  setEditLoading,
  setIsLoadingButtonCreate,
  setIsLoadingButtonEdit,
  setEditCompleted,
  setIsLoading,
  setQueryModules,
  setRunQueryButtonLoading,
  setQueryOutputTableData,
} from "../../../features/dataStoreReqSlice";

async function getBizLayerQuery(
  oauthTokenHeader: string | null,
  dispatch: any,
  setIsLoading: any
) {
  try {
    dispatch(setIsLoading(true));
    const response = await dataStoreServeices.getBizLayerQuery(
      oauthTokenHeader
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while biz quary",
          type: "error",
        })
      );
    } else {
      dispatch(setQuaryContent(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  } finally {
    dispatch(setIsLoading(false));
  }
}

async function getBizLayerQueryById(
  oauthTokenHeader: string | null,
  dispatch: any,
  setIsLoading: any,
  id: string,
  navigate: any
) {
  try {
    dispatch(setIsLoading(true));
    const response = await dataStoreServeices.getBizLayerQueryById(
      oauthTokenHeader,
      id
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while biz quary",
          type: "error",
        })
      );
    } else {
      dispatch(setQueryContentSingle(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    navigate(`/admin/queries/`);
  } finally {
    dispatch(setIsLoading(false));
    dispatch(setEditLoading(false));
  }
}

async function getBizLayerQueryModules(
  oauthTokenHeader: string | null,
  dispatch: any,
  setIsLoading: any
) {
  try {
    dispatch(setIsLoading(true));
    const response = await dataStoreServeices.getBizLayerQueryModules(
      oauthTokenHeader
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while biz quary module",
          type: "error",
        })
      );
    } else {
      dispatch(setQueryModules(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  } finally {
    dispatch(setIsLoading(false));
  }
}

async function postMetaData(oauthTokenHeader: any, data: any, dispatch: any) {
  try {
    dispatch(setIsLoadingButtonCreate(true));
    const response = await dataStoreServeices.postMetaData(
      oauthTokenHeader,
      data
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong",
          type: "error",
        })
      );
    } else {
      dispatch(setDbMetaDataPostFailed(false));
      dispatch(setOutputValues(response?.data?.data));

      return true;
    }
  } catch (e: any) {
    dispatch(setDbMetaDataPostFailed(true));
    dispatch(setHasErrorMessage(e));
    return false;
    // navigate(`/admin/queries/datastore_request/`);
  } finally {
    dispatch(setIsLoadingButtonCreate(false));
  }
}

async function postMetaDataEdit(
  oauthTokenHeader: any,
  data: any,
  dispatch: any
) {
  try {
    dispatch(setIsLoadingButtonEdit(true));
    const response = await dataStoreServeices.postMetaData(
      oauthTokenHeader,
      data
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong",
          type: "error",
        })
      );
    } else {
      dispatch(setDbMetaDataPostFailed(false));
      dispatch(setOutputValues(response?.data?.data));

      return true;
    }
  } catch (e: any) {
    dispatch(setDbMetaDataPostFailed(true));
    dispatch(setHasErrorMessage(e));
    return false;
    // navigate(`/admin/queries/datastore_request/`);
  } finally {
    dispatch(setIsLoadingButtonEdit(false));
  }
}

async function postBizLayerQuery(
  oauthTokenHeader: any,
  data: any,
  dispatch: any
) {
  try {
    dispatch(setIsLoadingButtonCreate(true));
    const response = await dataStoreServeices.postBizLayerQuery(
      oauthTokenHeader,
      data
    );
    if (!response.status || response.status !== 201) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong",
          type: "error",
        })
      );
    } else {
      dispatch(setCreateBizQueryFailed(false));
      dispatch(
        setDisplayErrorSnackBar({
          message: "Request Successfully Created",
          type: "success",
        })
      );
      return true;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    dispatch(setCreateBizQueryFailed(true));
    return false;
    // navigate(`/admin/queries/datastore_request/`);
  } finally {
    dispatch(setIsLoadingButtonCreate(false));
  }
}

async function putBizLayerQuery(
  oauthTokenHeader: any,
  data: any,
  dispatch: any,
  query_id: any
) {
  try {
    dispatch(setIsLoadingButtonEdit(true));
    dispatch(setEditCompleted(false));
    const response = await dataStoreServeices.putBizLayerQuery(
      oauthTokenHeader,
      data,
      query_id
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong",
          type: "error",
        })
      );
    } else {
      dispatch(setCreateBizQueryFailed(false));
      dispatch(
        setDisplayErrorSnackBar({
          message: "Request Successfully Updated",
          type: "success",
        })
      );
      dispatch(setEditCompleted(true));
      return true;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    dispatch(setCreateBizQueryFailed(true));
    return false;
    // navigate(`/admin/queries/`);
  } finally {
    dispatch(setIsLoadingButtonEdit(false));
    // dispatch(setEditCompleted(false));
  }
}

async function deleteBizLayerQuery(
  oauthTokenHeader: any,
  dispatch: any,
  query_id: any
) {
  try {
    dispatch(setIsLoading(true));
    const response = await dataStoreServeices.deleteBizLayerQuery(
      oauthTokenHeader,
      query_id
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong",
          type: "error",
        })
      );
    } else {
      dispatch(
        setDisplayErrorSnackBar({
          message: "Query Successfully Deleted",
          type: "success",
        })
      );

      return true;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    return false;
  } finally {
    dispatch(setIsLoading(false));
  }
}

async function runBizLayerQuery(
  oauthTokenHeader: any,
  dispatch: any,
  query_id: any,
  inputs: any
) {
  try {
    dispatch(setRunQueryButtonLoading(true));
    dispatch(setQueryOutputTableData(null));
    const response = await dataStoreServeices.runBizLayerQuery(
      oauthTokenHeader,
      query_id,
      inputs
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong",
          type: "error",
        })
      );
    } else {
      dispatch(
        setDisplayErrorSnackBar({
          message: "Query Successfully Run",
          type: "success",
        })
      );
      dispatch(setQueryOutputTableData(response?.data?.data));

      return true;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    return false;
  } finally {
    dispatch(setRunQueryButtonLoading(false));
  }
}

export const DataStoreReqEndPointLogic = {
  getBizLayerQuery,
  getBizLayerQueryById,
  getBizLayerQueryModules,
  postMetaData,
  postMetaDataEdit,
  postBizLayerQuery,
  putBizLayerQuery,
  deleteBizLayerQuery,
  runBizLayerQuery,
};
